const inteiro = new Intl.NumberFormat('pt-BR');
const reais = new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const reais4 = new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 4, maximumFractionDigits: 4 });
const custo = new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 6 });
const peso = new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 5 });
const pct = new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const dataHora = new Intl.DateTimeFormat('pt-BR', { dateStyle: 'short', timeStyle: 'short' });

const traco = '—';

export function formatarInteiro(n: number): string {
  return inteiro.format(n);
}

/** 1234.5 → "1.234,50". */
export function formatarReais(v: number | null | undefined): string {
  return v === null || v === undefined ? traco : reais.format(v);
}

/** Preço por kg: 4 casas. */
export function formatarReaisKg(v: number | null | undefined): string {
  return v === null || v === undefined ? traco : reais4.format(v);
}

/** Custo/kg: até 6 casas (como cadastrado). */
export function formatarCusto(v: number | null | undefined): string {
  return v === null || v === undefined ? traco : custo.format(v);
}

export function formatarPeso(v: number | null | undefined): string {
  return v === null || v === undefined ? traco : peso.format(v);
}

/** 16.2 → "16,20%". Com sinal: "+16,20%". */
export function formatarPct(v: number | null | undefined, comSinal = false): string {
  if (v === null || v === undefined || !Number.isFinite(v)) return traco;
  const texto = `${pct.format(v)}%`;
  return comSinal && v > 0 ? `+${texto}` : texto;
}

/** ISO → "11/09/2026, 14:32". */
export function formatarDataHora(iso: string | null | undefined): string {
  if (!iso) return traco;
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? traco : dataHora.format(d);
}

/** Data do CIGAM (sem fuso, chega como meia-noite UTC) → "31/12/2026". */
export function formatarDataCigam(iso: string | null | undefined): string {
  if (!iso) return traco;
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? traco : new Intl.DateTimeFormat('pt-BR', { timeZone: 'UTC' }).format(d);
}

/** plural(1, 'item', 'itens') → "1 item"; plural(3, 'item', 'itens') → "3 itens". */
export function plural(n: number, singular: string, pluralForma = `${singular}s`): string {
  return `${formatarInteiro(n)} ${n === 1 ? singular : pluralForma}`;
}

/**
 * Texto digitado em formato brasileiro → número. Aceita "15,72", "15.72", "1.234,56".
 * Vazio → null; inválido → NaN.
 */
export function lerNumero(texto: string): number | null {
  let s = texto.trim().replace(/\s/g, '').replace(/^R\$/i, '').replace(/%$/, '');
  if (!s) return null;
  if (s.includes(',')) s = s.replace(/\./g, '').replace(',', '.');
  if (!/^-?\d*(\.\d+)?$/.test(s) || s === '-' || s === '') return Number.NaN;
  return Number(s);
}

/** Número → texto para um campo editável ("15,724424", sem separador de milhar). `fixo` mantém os zeros ("5,10"). */
export function paraCampo(v: number | null | undefined, casas = 6, fixo = false): string {
  if (v === null || v === undefined) return '';
  return (fixo ? v.toFixed(casas) : String(Number(v.toFixed(casas)))).replace('.', ',');
}
